import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import { Badge } from 'reactstrap';
import CoachAssignModel from './components/CoachAssignModel'
import { tsToDate } from '../../../../../util/dateUtil'

class Coach extends React.Component {

    componentDidMount() {
        if (this.props.player.playerInView === null) {
            this.props.history.push('/app/players')
        }
    }
    coachItem(coach, playerId, eacl, key) {
        return (
            <div className="media jr-featured-item" key={key}>
                <div className="media-body jr-featured-content">
                    <div className="jr-featured-content-left">
                        <h4 className="mb-2">{coach.coachName} <Badge className="jr-rounded-xs text-uppercase" color={coach.status === "active" ? "info" : "warning"}>{coach.status}</Badge></h4>
                        <h5 className="mb-2">{coach.euid}</h5>
                        <div className="row-flex">
                            <div className="media text-grey mb-1">
                                <span className="media-body">Activation Date: {tsToDate(coach.startDateTs)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="jr-featured-content-right jr-profile-content-right">
                        <p className="text-primary text-truncate mt-sm-auto mb-0 pointer">
                            <CoachAssignModel
                                playerId={playerId}
                                currentCoachUid={coach.euid}
                                eacl={eacl}
                                action="change"
                            />
                        </p>
                        <p className="text-primary text-truncate mt-sm-auto mb-0 pointer">
                            <CoachAssignModel
                                playerId={playerId}
                                currentCoachUid={coach.euid}
                                action="remove"
                            />
                        </p>
                    </div>
                </div>
            </div>
        )
    }
    render() {
        const { playerInView } = this.props.player
        const eacl = playerInView != null ? (playerInView.hasOwnProperty("eacl") ? playerInView.eacl : null) : null
        const playerId = playerInView != null ? (playerInView.hasOwnProperty("uid") ? playerInView.uid : null) : null
        return (
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8 col-sm-12 col-xs-12">
                            <div className="d-flex flex-row my-3">
                                <h1 className="mb-0">Coaches</h1>
                                <span className="text-primary ml-auto pointer d-none d-sm-inline-flex align-items-sm-center">
                                    <CoachAssignModel
                                        playerId={playerId}
                                        eacl={eacl}
                                        action="add"
                                    />
                                </span>
                            </div>
                            <hr />
                        </div>
                        <div className="col-md-2"></div>
                    </div>
                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8 col-sm-12 col-xs-12">
                            <div className="pt-md-3">
                                {
                                    eacl != null ?
                                        eacl.map((data, index) => {
                                            if (data.status !== "revoked") {
                                                return this.coachItem(data, playerId, eacl, index)
                                            } else {
                                                return ''
                                            }
                                        }) : <div className="text-center">No coach assigned yet!</div>
                                }
                            </div>
                        </div>
                        <div className="col-md-2"></div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ player }) => {
    return { player }
};
export default withRouter(connect(mapStateToProps)(Coach));